import { useMemo } from 'react';
import { type BalloonSettingsPayload, type BalloonGfvSettingsPayload } from '../../../../../../api';
import { type VariantOption } from '../../../shared/useSelectedVariants';
import { type BalloonTableRecord } from './shared';

const useRecords = (
    variants: VariantOption[],
    balloonSettings: BalloonSettingsPayload | BalloonGfvSettingsPayload,
    terms: number[]
): BalloonTableRecord[] =>
    useMemo<BalloonTableRecord[]>(() => {
        if (!balloonSettings || !terms?.length || !variants?.length) {
            return [];
        }

        const { table } = balloonSettings;

        const getValue = (variantSuiteId: string, term: number) => {
            const row = table.find(row => row.variantSuiteId === variantSuiteId && row.term === term);

            return row?.value;
        };

        const results: BalloonTableRecord[] = variants.map(variant => {
            const termsValue = {};
            terms.forEach(term => {
                termsValue[`term${term}`] = getValue(variant.id, term);
            });

            return {
                key: variant.id,
                variantSuiteId: variant.id,
                variantId: variant.identifier,
                variantName: `${variant.name} (${variant.identifier})`,
                variantNameFromParameter: `${variant.name} (${variant.identifier})`,
                ...termsValue,
            };
        });

        return results;
    }, [variants, balloonSettings, terms]);

export default useRecords;
